import React, { Component } from 'react';
import './style.scss';
import { Table, Popconfirm, Tag } from 'antd';
import FormModal from './components/FormModal';
import { CloseOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types'
import { getDiscounts, createDiscount, updateDiscount, deleteDiscount } from './actions';

class Discounts extends Component {
  static contextTypes = {formatMessage: PropTypes.any}

  constructor(props) {
    super(props)
    this.state = {
      spinner: true,
      discounts: [],
      isOpen: false,
      item: {}
    }
  }
  
  async componentDidMount(){
    try {
      const discounts = await getDiscounts();
      this.setState({
        discounts,
        spinner: false
      })
    } catch (error) {
      
    }
  }


  submit = async (data) => {
    const {discounts} = this.state;
    
    if(data.id){
      let plan = await updateDiscount(data);
      this.setState({discounts: discounts.map(i => i.id == plan.id ? plan : i)})
    } else {
      let plan = await createDiscount(data);
      this.setState({discounts: [...discounts, plan]})
    }
    this.setState({isOpen: false, item: {}})
  }

  render() {
    const {formatMessage} = this.context;
    
    const {discounts, isOpen, item, spinner} = this.state;
    const columns = [
      {
        title: formatMessage('titleDiscount'),
        dataIndex: 'title',
        key: 'title',
      }, 
      {
        title: formatMessage('promo_codeDiscount'),
        dataIndex: 'promo_code',
        key: 'promo_code',
      },
      {
        title: formatMessage('publishedDiscount'),
        dataIndex: 'published',
        key: 'published',
        render: status => 
          <Tag color={ status ? 'green' : 'volcano'}>
            {status ? formatMessage('active_discount') : formatMessage('not_active_discount')}    
          </Tag>
        ,
      },
      {
        title: formatMessage('percentageDiscount'),
        dataIndex: 'percentage',
        key: 'percentage',
      },
      {
        title: formatMessage('number_of_usesDiscount'),
        dataIndex: 'number_of_uses',
        key: 'number_of_uses',
      },
      
      {
        title: formatMessage('used_by_usersDiscount'),
        dataIndex: 'used_by_users',
        key: 'used_by_users',
      },
      {
        title: '',
        render: (item) => {
          return <div className="actions-table">
            <i onClick={() => {this.setState({isOpen: true, item})}} className="icon far fa-edit"></i>
            <Popconfirm
              title={formatMessage('msgDeletePlanPayment')}
              icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
              onConfirm={ async() => {
                await deleteDiscount(item);
                this.setState({
                  discounts: discounts.filter(i => i.id != item.id),
                })
              }}
            >
              <CloseOutlined />
            </Popconfirm>
          </div>
        },
        key: 'actions',
      },
    ];
    return (
      <div className="Discounts row">
        <div className="col-md-12">
          <div className="actions">
            <button
              className="btn btn-primary"
              type="submit"
              onClick={() => this.setState({isOpen: true, item: {}})}
            >{formatMessage('AddNewDiscount')}</button>
          </div>
          {isOpen && <FormModal 
            item={item} 
            initialValues ={item} 
            save={this.submit} 
            isOpen={isOpen} 
            handleClose={() => {this.setState({isOpen: false, item: {}})}} 
          />}
          <Table loading={spinner} dataSource={discounts} columns={columns} bordered pagination={false} />
        </div>
      </div>
    );
  }
}

export default Discounts;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/AdminPanel/Discounts/index.jsx